import { dayjs } from "@thalamos/common";

import type {
  AutoSaveAction,
  AutoSaveState,
} from "../components/types/form.js";

export const initalAutoSaveState = {
  isLoading: false,
  hasAttemptedSave: false,
  error: false,
  lastSavedAt: undefined,
};
export function autoSaveStateReducer(
  prevState: AutoSaveState,
  action: AutoSaveAction,
): AutoSaveState {
  switch (action) {
    case "loading":
      return {
        isLoading: true,
        hasAttemptedSave: true,
        error: false,
        lastSavedAt: prevState.lastSavedAt,
      };
    case "success":
      return {
        isLoading: false,
        hasAttemptedSave: true,
        error: false,
        lastSavedAt: dayjs(),
      };
    case "error":
      return {
        isLoading: false,
        hasAttemptedSave: true,
        error: true,
        lastSavedAt: prevState.lastSavedAt,
      };
  }
}
